// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 966) return "static/chunks/966-01f38e873aed56f5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"141":"5dffa6623452a050","189":"bda8b634a0a767a2","196":"870199642735e3b3","307":"434ec62f8328258d","817":"5674bd38d032750a","943":"8e3ae2511201f7ee"}[chunkId] + ".js";
};